import { MapContainer, TileLayer, Marker, Popup, LayersControl } from 'react-leaflet';
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setPointMapStation } from "../../redux/actions/mapActions";
import React from 'react';
import L from 'leaflet';

const { BaseLayer } = LayersControl

export function MapStation() {
  const dispatch = useDispatch();
  const points = useSelector(state => state.map.pointsStation);

  useEffect(() => {
    if (!points || points.length === 0) {
      const guardados = localStorage.getItem("pointsStation");
      if (guardados) {
        dispatch(setPointMapStation(JSON.parse(guardados)));
      }
    }
  }, [points, dispatch]);

const getCustomIcon = () => {

  let iconSize = [24, 24];
  let iconUrl = "assets/img/triangle_esta.png";

  return L.icon({
    iconUrl,
    iconSize, 
    iconAnchor: [iconSize[0] / 2, iconSize[1] / 2], 
    popupAnchor: [0, -iconSize[1] / 2],
    className: ""
  });
};

return (
  <MapContainer
    center={[4.6, -74.1]}
    zoom={6}
    style={{ height: '100vh', width: '100%' }}
  >
    <LayersControl position="topright">
      {/* Capa base 1 */}
      <BaseLayer checked name="Esri Topo Map">
        <TileLayer
          url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}"
          attribution="Tiles &copy; Esri &mdash; Source: USGS, Esri"
          maxZoom={20}
        />
      </BaseLayer>

      {/* Capa base 2 */}
      <BaseLayer name="OpenStreetMap">
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution="&copy; OpenStreetMap contributors"
        />
      </BaseLayer>

      {/* Capa base 3 */}
      <BaseLayer name="Esri Satellite">
        <TileLayer
          url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
          attribution="Tiles &copy; Esri"
        />
      </BaseLayer>

       {points.length > 0 &&
        points.map((point, idx) => (
          <Marker
            key={idx}
            position={[
              parseFloat(point.latitude),
              parseFloat(point.longitude)
            ]}
            icon={getCustomIcon()} // <-- ícono dinámico
          >
            <Popup>
                {point.name ? (
                    point.name
                ) : (
                    <>                
                    Lat: {point.latitude}, Lon: {point.longitude}
                    </>
                )}
            </Popup>
          </Marker>
        ))}
    </LayersControl>    
  </MapContainer>
);
};

export default MapStation;